/**
 * Created by mukund on 1/7/18.
 *
 * Scheduler Service
 */

'use strict';

angular.module('mediacloudApp')
    .factory('SchedulerService',['$interval', '$resource', function($interval, $resource){

        var dateTimePicker = {
            timeZones : [{
                key: "America/Los_Angeles",
                value: "Pacific Time (US and Canada)"
            }, {
                key: "America/Denver",
                value: "Mountain Time (US and Canada)"
            }, {
                key: "America/Chicago",
                value: "Central Time (US and Canada)"
            }, {
                key: "America/New_York",
                value: "Eastern Time (US and Canada)"
            }],
            dateFormats : ['MM/dd/yyyy', 'dd/MM/yyyy'],
            config : {
                formatYear: 'yy',
                startingDay: 1,
                showWeeks: false,
                maxMode: 'day',
                formatDay: 'd'
            }
        };

        return {
            getDateTimePicker: function(){
                return dateTimePicker;
            },
            copyDatesWithoutTimeChange: function(date, newDate){
                date.setDate(newDate.getDate());
                date.setMonth(newDate.getMonth());
                date.setFullYear(newDate.getFullYear());
            },
            checkAvailability: $resource('api/scheduler/available'),
            getTimezone: $resource('api/scheduler/timezone'),
            getContributors: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/scheduler/getContributors');
                return resource.query({ baseCollectionId: args.baseCollectionId },
                    function(response){
                        return cb(response);
                    }, function(err){
                        return cb(err);
                    }).$promise;
            },
            OAuth: $resource('api/zoom/oauth'),
            GoogleOAuth: $resource('api/google/oauth'),
            GoogleStatus: $resource('api/google/status'),
            ZoomStatus: $resource('api/zoom/status'),
            IntegrationProvider: $resource('api/properties', {name: 'INTEGRATION_PROVIDER'}),
            GoogleAddEvent: function(params){
                return $resource('api/google/meeting/schedule', {}, {
                    save: {
                        method: 'POST',
                        params: params,
                        isArray: false
                    }
                });
            },
            GetZoomRecordings: $resource('api/zoom/recordings'),
            UserVideoSettings: $resource('api/zoom/uservideosetting'),
            UserRecordingInProgress: $resource('api/zoom/userrecordinginprogress'),
            ImportZoomRecordings: $resource('api/zoom/import'),
            SetPlayFromZoomOpened: $resource('api/zoom/setplayfromzoomopened'),
            CancelAll: $resource('api/zoom/cancelall'),
            CancelSingle: $resource('api/zoom/cancelsingle'),
            addEvent: function(params){
                return $resource('api/zoom/meeting/schedule', {}, {
                    save: {
                        method: 'POST',
                        params: params,
                        isArray: false
                    }
                });
            },
            editEvent: function(params){
                return $resource('api/zoom/meeting/update', {}, {
                    save: {
                        method: 'PUT',
                        params: params,
                        isArray: false
                    }
                });
            },
            deleteEvent: $resource('api/zoom/meeting/delete',{},{
                erase: {
                    method: 'DELETE', params: {}, isArray: false
                }
            }),
            GoogleEditEvent: function(params){
                return $resource('api/google/meeting/update', {}, {
                    save: {
                        method: 'PUT',
                        params: params,
                        isArray: false
                    }
                });
            },
            GoogleDeleteEvent: $resource('api/google/meeting/delete',{},{
                erase: {
                    method: 'DELETE', params: {}, isArray: false
                }
            }),
            getRecurringEvents: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/zoom/list/recurring');
                return resource.get({
                            baseCollectionId: args.baseCollectionId,
                        },
                        function(response){
                            return cb(response);
                        }, function(err){
                            return cb(err);
                        }).$promise;
            },
            getEvents: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/zoom/list/events');
                return resource.get({
                            startDateTime: args.startDateTime,
                            endDateTime: args.endDateTime,
                            timeZone: args.timeZone,
                            baseCollectionId: args.baseCollectionId,
                            page: args.page,
                            size: args.size
                        },
                        function(response){
                            return cb(response);
                        }, function(err){
                            return cb(err);
                        }).$promise;
            },
            getGoogleEvents: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/google/list/events');
                return resource.get({
                            startDateTime: args.startDateTime,
                            endDateTime: args.endDateTime,
                            timeZone: args.timeZone,
                            baseCollectionId: args.baseCollectionId,
                            page: args.page,
                            size: args.size
                        },
                        function(response){
                            return cb(response);
                        }, function(err){
                            return cb(err);
                        }).$promise;
            },
            getEventCount: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/zoom/list/countByStartTimeGreaterThan');
                return resource.get({ baseCollectionId: args.baseCollectionId, startDateTime: args.startDateTime, timeZone: args.timeZone },
                    function(response){
                        return cb(response);
                    }, function(err){
                        return cb(err);
                    }).$promise;
            },
            getEventCountForCollection: $resource('api/zoom/list/countByBaseCollectionId')
        };
    }]);
